export const textParamsParser = (text: string, params: string[]) => {
  params.forEach((param, index) => {
    const reg = new RegExp(`\\$${index + 1}`, "g");
    text = text.replace(reg, params[index]);
  });
  return text;
};
